/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Year_FilterInputs */

const en_last_year_filter = /** @type {(inputs: Last_Year_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last year`)
};

const nl_last_year_filter = /** @type {(inputs: Last_Year_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgelopen jaar`)
};

/**
* | output |
* | --- |
* | "Last year" |
*
* @param {Last_Year_FilterInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_year_filter = /** @type {((inputs?: Last_Year_FilterInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Year_FilterInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_last_year_filter(inputs)
	return en_last_year_filter(inputs)
});